import React from 'react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { RoutePermissionsMapping } from 'account/permissions/mapping'
import { Menu, Select } from 'antd'

import { Permissions } from 'core/application/account/permissions'

import useSwitchProduct from 'common/hooks/useSwitchProduct'

import { useLoginUser } from 'common/hooks'
import { ProductConfig } from 'common/providers/ProductProvider'

import IchraDecisionToolsLogo from 'assets/images/IchraDecisionToolLogo'
import ReviewerAppIcon from 'assets/images/ReviewerAppIcon'

import Icon from '../../general/Icon'

import './InternalToolsHeaderSwitch.less'

const { Option } = Select

interface InternalToolsHeaderSwitchProps {
  defaultValue: number
}

const InternalToolsHeaderSwitch = ({ defaultValue }: InternalToolsHeaderSwitchProps) => {
  const history = useHistory()
  const { t: translate } = useTranslation()

  const [user] = useLoginUser()

  const handleSwitch = useCallback(() => {
    if (user.canAccessAdminDashboard) history.push('/admin-dashboard')
    else history.push('/eligible-employee-dashboard')
  }, [user.canAccessAdminDashboard])

  const { handleSwitchProduct } = useSwitchProduct(handleSwitch)

  const goToRoute = (permission: Permissions) => {
    const route: string | undefined = RoutePermissionsMapping.get(permission)

    window.location.href = '' + route
  }

  const handleGetValue = (e: Permissions) => {
    switch (e) {
      case Permissions.AccessCsiDashboard:
        return -1
      case Permissions.AccessDocReviewDashboard:
        return -2
      case Permissions.AccessIchraDecisionTools:
        return -3
      default:
        return 0
    }
  }

  const handleSelectChange = (e: number) => {
    switch (e) {
      case -1:
        return goToRoute(Permissions.AccessCsiDashboard)
      case -2:
        return goToRoute(Permissions.AccessDocReviewDashboard)
      case -3:
        return goToRoute(Permissions.AccessIchraDecisionTools)
      default:
        return handleSwitchProduct(user.companyId, e)
    }
  }

  return (
    <Menu.Item className="InternalToolsMenu no_hover_styles">
      <Select
        defaultValue={handleGetValue(defaultValue)}
        className="ml-16"
        popupClassName="InternalToolsMenuDropdown"
        onChange={(e) => {
          handleSelectChange(e)
        }}
      >
        {user.canAccessCsiDashboard && (
          <Option key={1} value={-1}>
            <div className="flex t-switch-product-csi">
              <div className="mr-8">
                <Icon type="far fa-cog" fontAwesome className="color-green-6" />
              </div>
              <div className="color-gray-8">{translate('csi-dashboard.navigation.title')}</div>
            </div>
          </Option>
        )}
        {user.canAccessDocReviewDashboard && (
          <Option key={2} value={-2}>
            <div className="flex flex__align_center t-switch-product-doc-review">
              <ReviewerAppIcon />
              <div className="color-gray-8 ml-4">{translate('doc-review-dashboard.menu.title')}</div>
            </div>
          </Option>
        )}
        {user.canAccessIchraDecisionTool && (
          <Option key={3} value={-3}>
            <div className="flex t-switch-product-decision-tool">
              <IchraDecisionToolsLogo />
            </div>
          </Option>
        )}
        {user.products.map((product) => (
          <Option key={4} value={product.id}>
            <img
              className={`pk--header-product-logo t-switch-product-${product.id}`}
              src={ProductConfig.get(product.id).productLogo}
              alt=""
            />
          </Option>
        ))}
      </Select>
    </Menu.Item>
  )
}

export default InternalToolsHeaderSwitch
